import { render, staticRenderFns } from "./vendorCreate.vue?vue&type=template&id=2f464fe1&scoped=true"
import script from "./vendorCreate.vue?vue&type=script&lang=js"
export * from "./vendorCreate.vue?vue&type=script&lang=js"
import style0 from "./vendorCreate.vue?vue&type=style&index=0&id=2f464fe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f464fe1",
  null
  
)

export default component.exports